var exports = {
  "nV": "xe533113f--e16ae2--gallery",
  "q9": "xe533113f--e16ae2--price",
  "hl": "xe533113f--e16ae2--address",
  "DD": "xe533113f--e16ae2--title",
  "kp": "xe533113f--e16ae2--kp",
  "qT": "xe533113f--e16ae2--features",
  "U1": "xe533113f--e16ae2--redirect-btn",
};

module.exports = exports;
